import React from 'react';
import Slider from 'react-slick';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ImageSlider(){
    let settings = {
        dot: true,
        infinite: true,
        speed: 500,
        slideToShow:4,
        
    }
    return (
        <div>

        </div>
    )
}

export default ImageSlider